import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Whisper, Popover } from 'rsuite';
import { Link } from 'react-router-dom';

import styles from './LockableContent.module.less';

const getPopover = (content) => (
  <Popover>
    <div className={styles.vpUpgradePopover}>{content}</div>
  </Popover>
);

const defaultSpeaker = getPopover(
  <>
    Upgrade on the <Link to="/billing">billing page</Link> to access this feature.{' '}
  </>
);

const LockableContent = ({
  className,
  isContentLocked,
  children,
  customPopoverText,
  popoverPlacement = 'auto',
  hideLock
}) => {
  if (isContentLocked) {
    const speaker = customPopoverText ? getPopover(customPopoverText) : defaultSpeaker;

    return (
      <Whisper enterable speaker={speaker} placement={popoverPlacement}>
        <div className={`${className} ${styles.vpLockedContent}`}>
          {children}
          {isContentLocked && !hideLock && <Icon size="lg" className={styles.vpLock} icon="lock" />}
        </div>
      </Whisper>
    );
  }

  return children;
};

LockableContent.propTypes = {
  className: PropTypes.string,
  isContentLocked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  customPopoverText: PropTypes.node,
  popoverPlacement: PropTypes.string,
  hideLock: PropTypes.bool
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LockableContent);



// WEBPACK FOOTER //
// ./src/components/LockableContent/LockableContent.jsx